import Button from "shared/UI/Buttons/Button";

type FormSubmitButtonProps = {
  text: string;
  onClick?: VoidFunction;
  disabled: boolean;
  type?: "submit" | "button";
};

export const FormSubmitButton = (props: FormSubmitButtonProps) => {
  return (
    <Button
      className="max-w-[200px]"
      type={props.type ?? "button"}
      text={props.text}
      onClick={props.onClick}
      disabled={props.disabled}
    />
  );
};

FormSubmitButton.defaultProps = { disabled: false };
